
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import { SaleLayoutFreeLine } from "@/utils/sale-layouts/free-line";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import Vue from "vue";
import AppFieldEdit from "./FieldEdit.vue";
import AppSelectFreeLinePlacement from "./SelectFreeLinePlacement.vue";

export default Vue.extend({
	data() {
		return {
			selectedLang: "",
			toEditStyleLine: null as null | SaleLayoutFreeLine,
			toEditLine: null as null | SaleLayoutFreeLine
		};
	},
	props: {
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		}
	},
	computed: {
		lines():SaleLayoutFreeLine[]{
			return this.layout.FreeLines;
		}
	},
	methods: {
		removeLine(i: number) {
			this.layout.logoPlacementRemoved(this.lines[i].Key);
			this.lines.splice(i,1);
		},
		editLine(line: SaleLayoutFreeLine) {
			this.toEditLine = line;
		},
		editStyle(style: SaleLayoutFreeLine) {
			this.toEditStyleLine = style;
		},
		createNew() {
			let line = new SaleLayoutFreeLine();
			this.lines.push(line);
			this.toEditLine = line;
		}
	},
	components: {
		AppCustomLangSelect,
		AppStyleEditor,
		AppFieldEdit,
		AppSelectFreeLinePlacement
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
